

import PointyIcon from '~/assets/icons/pointy.svg'
import RoundedIcon from '~/assets/icons/rounded.svg'
import SlightyPointedIcon from '~/assets/icons/slightly-pointy.svg'

export default {
  name: 'Scale',
  components: {
    PointyIcon,
    RoundedIcon,
    SlightyPointedIcon
  },
  props: {
    slider: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedProgress () {
      const markIndex = this.slider.value
      // using hardcoded percentages
      const markPercentage = {
        1: '5%',
        2: '29%',
        3: '52%',
        4: '76%',
        5: '100%'
      }
      return markPercentage[markIndex] || '0%'
    },
    scaleNames () {
      return this.slider.scaleName
    }
  },
  methods: {

    shouldBoldenLabel (index) {
      if (this.scaleNames === 'cupShape') {
        const value = this.slider.value
        return ((value === 1 || value === 2) && index === 0) ||
        (value === 3 && index === 2) ||
        ((value === 4 || value === 5) && index === 4)
      }
      if (this.scaleNames === 'Support') {
        const value = this.slider.value
        return ((value === 1 || value === 2) && index === 0) ||
        (value === 3 && index === 2) ||
        ((value === 4 || value === 5) && index === 4)
      }
      return false
    },
  }
}
